import { APP_INITIALIZER, EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { RealtimeGatewayService } from './realtime-gateway.service';

export function provideRealtimeGateway(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: (realtimeGatewayService: RealtimeGatewayService) => () => realtimeGatewayService,
      deps: [RealtimeGatewayService]
    }
  ]);
}
